module.exports = __webpack_public_path__ + "static/media/fi-rr-trash.d93ee263.svg";